import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type AdvertTargetProperties = {
  clickref: string;
  destination_url: string;
  retailer_id?: string;
};

type EventData = {
  clickref: string;
  destinationUrl: string;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  retailerId?: string;
};

class AdvertInteractionEvent extends InteractionEvent<
  EventData,
  AdvertTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'advert';
  }

  protected getTargetProperties(): AdvertTargetProperties {
    return {
      clickref: this.data.clickref,
      destination_url: this.data.destinationUrl,
      retailer_id: this.data.retailerId
    };
  }
}

export default AdvertInteractionEvent;
